$(function(){
    console.log('Jumpstart Scripts');
    initflickityCarouselGallerycomparison();
    initFlickityFeaturedCollection();
    handleCollectionTabClick();
    gridflickityproductTabs();
    replacenoscriptimgglossary();
    navigationglossary();
    opencloseaccordionglossaryonload();
    pdpDescReadMore();
    cartJsEvent();
    initClickableBanner();
    upsellPDPSelectButton();
    initFlickityUpsellCarousel();
    initFlickityMediaGallery();
    initTextImageFlickity();
    multicolumnVideo();
    setTimeout(function(){
        cartDrawerUpt();
    },500);
    if (location.href.includes('/cart')) {
        masterPromo();
    }
    if (location.href.includes('/products')) {
      jscReadMore_productDesc();
  }
    checkCollectionTabsOverflow();
    
    // Check if product recommendations are ready before running getCardInformationMaxHeight
    checkProductRecommendationsAndRun();
    
    // Also run after images and resources are fully loaded
    $(window).on('load', function() {
        checkProductRecommendationsAndRun();
    });
    
    // Additional check for when DOM is fully ready
    $(document).ready(function() {
        setTimeout(function(){
            checkProductRecommendationsAndRun();
        }, 200);
    });

  if (location.href.includes('/collection')) {
    $(window).on('scroll', function () {
      // Only trigger on mobile width 480px or below
      if ($(window).width() <= 480) {
        $('.disclosure-has-popup[open]').each(function () {
          $(this)
            .removeAttr('open') // Close the details
            .find('.facets__display')
            .removeAttr('style'); // Remove fixed styles
        });
      }
    });
    onclickCollectionFilter();
  }
});

$(window).on('resize', function() {
  console.log('resize screen');
    getCardInformationMaxHeight();
    try {
      if ($(window).width() < 480) {
        
      } else {
        destroyFlickityFeaturedCollection();
        initFlickityFeaturedCollection();
      }
    } catch (error) {
        console.log('Error in resize handler:', error);
    }
    checkCollectionTabsOverflow();
});

// Start - cartjs general function
cartJsEvent = () =>{
    $(document).on('cart.requestStarted', function(event, cart) {
        $('.jsc-page-loading').show();
    });
    $(document).on('cart.requestComplete', function(event, cart) {
        $('.jsc-page-loading').hide();
    });
}

cartDrawerUpt = () => {
    $(document).on('cart.requestComplete', function(event, cart) {
        if (location.href.includes('/cart')) {
        location.reload();
        }else {
        fetch("?section_id=mini-cart")
        .then(response => response.text())
        .then(html => {
            document.getElementById('mini-cart').innerHTML =
            getThis.getSectionInnerHTML(html, '.shopify-section');
            getThis.open();
        })
        .catch(e => {
            console.error(e);
        });

        fetch("?section_id=cart-icon-bubble")
        .then(response => response.text())
        .then(html => {
            console.log(getThis);
            document.getElementById('cart-icon-bubble').innerHTML =
            getThis.getSectionInnerHTML(html, '.shopify-section');
            getThis.open();
        })
        .catch(e => {
            console.error(e);
        });

        }
    });
}
cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback

    CartJS.addItem(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
            console.log('before');
            },
            success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
                bubbles: isOpenDrawer,
                detail: {
                variant: vid,
                quantity: qty
                }
            }));
            */
            }
        });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        }
    });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback

    CartJS.updateItemById(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
            console.log('before');
            },
            success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
                bubbles: isOpenDrawer,
                detail: {
                variant: vid,
                quantity: qty
                }
            }));
            */
            }
        });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        }
    });
}
// End - cartjs general function

// Start - Product Recommendations Check
checkProductRecommendationsAndRun = () => {
    // Check if we're on a product page (where recommendations would appear)
    if (document.querySelector('product-recommendations')) {
        // Wait for product recommendations to be fully loaded
        const checkRecommendations = () => {
            const recommendations = document.querySelector('product-recommendations');
            
            // Check if recommendations have content and images are loaded
            if (recommendations && 
                recommendations.querySelectorAll('.grid__item').length > 0 &&
                recommendations.querySelectorAll('img').length > 0) {
                
                // Check if all images in recommendations are loaded
                const images = recommendations.querySelectorAll('img');
                let loadedImages = 0;
                let totalImages = images.length;
                
                if (totalImages === 0) {
                    // No images found, run immediately
                    getCardInformationMaxHeight();
                    return;
                }
                
                images.forEach(img => {
                    if (img.complete) {
                        loadedImages++;
                    } else {
                        img.addEventListener('load', () => {
                            loadedImages++;
                            if (loadedImages === totalImages) {
                                getCardInformationMaxHeight();
                            }
                        });
                        img.addEventListener('error', () => {
                            loadedImages++;
                            if (loadedImages === totalImages) {
                                getCardInformationMaxHeight();
                            }
                        });
                    }
                });
                
                // If all images are already loaded, run immediately
                if (loadedImages === totalImages) {
                    getCardInformationMaxHeight();
                }
            } else {
                // Recommendations not ready yet, try again in 100ms
                setTimeout(checkRecommendations, 100);
            }
        };
        
        // Start checking
        checkRecommendations();
        
        // Also listen for Shopify's product recommendations loaded event
        document.addEventListener('shopify:section:load', function(event) {
            if (event.target.tagName === 'PRODUCT-RECOMMENDATIONS') {
                // Wait a bit for the content to render, then check again
                setTimeout(() => {
                    checkProductRecommendationsAndRun();
                }, 200);
            }
        });
        
        // Listen for when recommendations are updated via AJAX
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // New content added, check if recommendations are ready
                    setTimeout(() => {
                        checkProductRecommendationsAndRun();
                    }, 100);
                }
            });
        });
        
        // Start observing the recommendations element
        if (recommendations) {
            observer.observe(recommendations, {
                childList: true,
                subtree: true
            });
        }
        
    } else {
        // No product recommendations on this page, run immediately
        getCardInformationMaxHeight();
    }
}
// End - Product Recommendations Check
// Start - onload and onclick all promo
masterPromo = (isDrawer) =>{
    console.log('masterPromo');

    setTimeout(function(){
        gwpFunction(isDrawer);
        cartGift();
    },100);

}
// End - onload and onclick all promo
// Start - Simple GWP promo
gwpFunction = (isOpenDrawer) =>{
    $.when($.getJSON('/cart.js', function(cart) {

    })).then(function(cart){
        var $gwpcart_product = {};
        var $addEle = $('.jsc-add-gwp');
        var $updateEle = $('.jsc-update-gwp');
        var $deleteEle = $('.jsc-remove-gwp');

        $gwpcart_product['_Promo'] = 'Free Gift';

        $addEle.each(function() {
        var $vid = parseInt($(this).val());
        var $qty = parseInt($(this).attr('data-qty'));

        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

        cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
        });

        $updateEle.each(function() {
        var $vid = $(this).val();
        var $qty = parseInt($(this).attr('data-qty'));

        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

        cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
        });

        $deleteEle.each(function() {
        var $vid = $(this).val();
        var $qty = 0;

        cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
        });

    });
}
// End - Simple GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () =>{
    addCartGift();
    removeCartGift();
}
  
addCartGift = () =>{
    var $loader = $('.jsc-loader-overlay');
    var $elem = $('.jsc-cart-gift');
    $elem.each(function(){
    $loader.show();
    var $vid = parseInt($(this).val());
    var $obj = {};
    var $promoNo = $(this).attr('data-promo');

    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';
    if ($elem.length > 0) {
        cartJSAddQuery($vid,1,$obj,true);
    }
    });
    $('.jsc-cart-gift-upt').each(function () {
        $loader.show();
        var $vid = $(this).val();
        var $qty = parseInt($(this).attr('data-qty'));

        var $obj = {};
        var $promoNo = $(this).attr('data-promo');
        $obj['_Cart_Gift'] = $promoNo;
        $obj['_Cart_GWP'] = 'Free Gift';

        cartJSUpdateQuery($vid, $qty, $obj, false);
    });
}

removeCartGift = () =>{
    var $loader = $('.jsc-loader-overlay');
    var $elem = $('.jsc-cart-gift-remove');
    $elem.each(function(){
    $loader.show();
    var $key = parseInt($(this).val());

    if ($elem.length > 0) {
        cartJSUpdateQuery($key, 0, {}, true);
    }
    });
}
//End GWP based on cart, product or collection promo
//Start - accordion glossary
opencloseaccordionglossaryonload = () => {
    $(".ingredient-glossary__accordion__trigger").on("click", opencloseaccordionglossary);
}
opencloseaccordionglossary = (evt) => {
    const trigger = $(evt.currentTarget);
    const content = trigger.next(".ingredient-glossary__accordion__content");

    // If this content is already open, close it
    if (content.is(":visible")) {
        content.animate({ height: 0 }, 400, function() {
        $(this).css("display", "none");
        });
    } 
    // Otherwise open it
    else {
        // First, display it but with 0 height
        content.css({
        display: "block",
        height: "0"
        });
        
        // Calculate the final height we want
        const autoHeight = content.prop("scrollHeight");
        
        // Animate to that height
        content.animate({ height: autoHeight }, 400, function() {
        // After animation completes, set to auto to handle content changes
        $(this).css("height", "");
        });
    }
}
replacenoscriptimgglossary = () => {
    // Replace images with noscript content and remove noscript tags
    $(".ingredient-glossary__accordion__content picture").each(function() {
        // Find the noscript element within this picture
        const noscriptContent = $(this).find("noscript").html();
        
        if (noscriptContent) {
        // Replace the placeholder img with the actual image from noscript
        $(this).find("img").replaceWith(noscriptContent);
        
        // Remove the noscript element
        $(this).find("noscript").remove();
        }
    });
}
navigationglossary = () => {
    // When clicking on any letter navigation link (using classes that start with "letter")
    $('a[class^="letter"]').on('click', function(e) {
        e.preventDefault(); // Prevent default anchor behavior
        
        // Get the letter class from the clicked link
        const letterClass = $(this).attr('class');
        
        // Close any open accordions
        $(".ingredient-glossary__accordion__content:visible").each(function() {
            $(this).animate({ height: 0 }, 400, function() {
                $(this).css("display", "none");
            });
        });
        
        // Remove active class from all letter links
        $('a[class^="letter"]').removeClass('active');
        
        // Add active class to clicked letter link
        $(this).addClass('active');
        
        // Remove active class from all glossary letter items
        $('.ingredient-glossary__letters__item').removeClass('active');
        
        // Hide all glossary letter items first
        $('.ingredient-glossary__letters__item').hide();
        
        // Add active class to the corresponding glossary letter item and show it
        console.log(letterClass);
        $('.ingredient-glossary__letters__item.' + letterClass)
            .addClass('active')
            .show();
    });
}
//End - accordion glossary
// Start - description read more function
pdpDescReadMore = () => {
    $('.read-more-link').on('click', function (e) {
        e.preventDefault();

        var $container = $(this).closest('.description-container');
        var $shortDesc = $container.find('.short-description');
        var $fullDesc = $container.find('.full-description');
        var $link = $(this);

        $shortDesc.toggle();
        $fullDesc.toggle();

        if ($fullDesc.is(':visible')) {
        $link.text('View less...');
        } else {
        $link.text('View more...');
        }
    });
}
// End - description view more function

//Start - Anchor button
anchorButton = () => {
    var $target = $('#back-to-top');
    if ($target.length) {
      $('html, body').animate({
        scrollTop: 0
      }, 600);
    }
}
//End - Anchor button

//Start - Loyalty Point Calculation
updateProductPoints = (price) => {
    console.log('updateProductPoints: ', price);
    const currentPrice = price ? parseInt(price, 10) : 0;
    if (currentPrice > 0 && $('.loyalty_point--container .product_point').length > 0) {
        var productPrice = currentPrice * 0.90 / 100;
        var points = Math.floor(productPrice);
        var pointPrice = points * 100;
        var formatedPrice = theme.Currency.formatMoney(pointPrice, theme.shopSettings.moneyFormat)
        $('.loyalty_point--container .product_point').text(points);
        $('.loyalty_point--container .product-point-conversion').text(formatedPrice);
    }
}
//End - Loyalty Point Calculation

//Start - Get card information max height
getCardInformationMaxHeight = () => {
    var maxCardTitleHeight = 0;
    var maxCardInfoHeight = 0;
  
    $('.card-information__text, .card-information__wrapper').css('height', 'auto');
  
    $('.card-information__text').each(function(){
      if ($(this).outerHeight() > maxCardTitleHeight) {
        maxCardTitleHeight = $(this).outerHeight();
      }
    });
  
    
    if ($(window).width() > 480) {
      // in desktop, make the title section have the same height
      $('.card-information__text').each(function(){
        // $(this).height(maxCardTitleHeight);
        $(this).height('fit-content'); // ##14448
      });
    } else {
      
    }
  
    $('.card-information__wrapper').each(function(){
      if ($(this).outerHeight() > maxCardInfoHeight) {
        maxCardInfoHeight = $(this).outerHeight();
      }
    });
  
    $('.card-information__wrapper').each(function(){
      $(this).height(maxCardInfoHeight);
    });
}
//End - Get card information max height
initflickityCarouselGallerycomparison = () =>{
    $('.gallery-comparison-wrap-desktop').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        autoPlay: 3000,
        arrowShape: { 
            x0: 0,
            x1: 40, y1: 40,
            x2: 45, y2: 35,
            x3: 10
          },
        prevNextButtons: true
    });
    $('.gallery-comparison-wrap-mobile').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        autoPlay: 3000,
        arrowShape: { 
            x0: 0,
            x1: 40, y1: 40,
            x2: 45, y2: 35,
            x3: 10
          },
        prevNextButtons: true
    });
}

//Start - Collection tabs & flickity featured collection
handleCollectionTabClick = () => {
    $('.collection-tab').on('click', function(e) {
        e.preventDefault();
        
        $('.collection-tab').removeClass('active');
        $('.tab-panel').removeClass('active');
        
        $(this).addClass('active');
        
        var panelId = $(this).attr('aria-controls');
        
        $('#' + panelId).addClass('active');
        
        // Clean up all Flickity instances
        $('.jsc-flickity-product-grid').each(function() {
            var $grid = $(this);
            try {
                if ($grid.data('flickity')) {
                    // $grid.find('.card-wrapper').css('height', 'auto'); // commented out to solve flickering issue #14350
                    // $grid.flickity('destroy'); // commented out to solve flickering issue #14350
                }
            } catch (error) {
                console.log('Error destroying Flickity:', error);
            }
        });
        
        setTimeout(function() {
            initFlickityFeaturedCollection();
        }, 100);
    });
}

initFlickityFeaturedCollection = () => {
    console.log("initFlickityFeaturedCollection");
    
    var $activeGrid = $('.tab-panel.active .jsc-flickity-product-grid');
    
    if ($('.tab-panel.active').length === 0) {
        $activeGrid = $('.jsc-flickity-product-grid');
    }
    $activeGrid = $('.jsc-flickity-product-grid'); // initiate flickity to each section by default to solve flickering issue #14350
    if ($activeGrid.length > 0) {
        $activeGrid.each(function() {
            var $grid = $(this);
            var itemCount = $grid.find('.grid__item').length;
            var isMobile = window.innerWidth < 750;
            
            try {
                // Destroy existing instance if it exists
                if ($grid.data('flickity')) {
                    // $grid.flickity('destroy'); // commented out to solve flickering issue #14350
                }
                
                // Reset heights
                $grid.find('.card-wrapper').css('height', 'auto');
                $grid.find('.flickity-button').remove();
                // Determine if dragging should be enabled based on item count
                var shouldEnableDragging = isMobile ? itemCount > 2 : itemCount > 4;
                
                // Create custom buttons
                var $prevButton = $('<button class="flickity-button flickity-button--previous" name="previous" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-arrow" fill="none" viewBox="0 0 14 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg></button>');
                var $nextButton = $('<button class="flickity-button flickity-button--next" name="next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-arrow" fill="none" viewBox="0 0 14 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"/></svg></button>');
                
                // Add buttons to the grid
                $grid.append($prevButton, $nextButton);
                
                var flickityOptions = {
                    cellAlign: 'left',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    groupCells: false,
                    wrapAround: shouldEnableDragging,
                    autoPlay: false,
                    draggable: shouldEnableDragging,
                    freeScroll: false,
                    cellSelector: '.grid__item',
                    resize: true,
                    imagesLoaded: true,
                    adaptiveHeight: false,
                    on: {
                        ready: function() {
                            try {
                                var $items = $grid.find('.grid__item');
                                var maxHeight = 0;

                                getCardInformationMaxHeight();

                                $items.each(function() {
                                    var height = $(this).find('.card-wrapper').outerHeight();
                                    if (height > maxHeight) maxHeight = height;
                                });
                                $items.each(function() {
                                    $(this).find('.card-wrapper').height(maxHeight);
                                });
                                
                                // Only resize if Flickity is properly initialized
                                if ($grid.data('flickity')) {
                                    $grid.flickity('resize');
                                }

                                // If dragging is disabled, ensure proper grid display
                                if (!shouldEnableDragging) {
                                    $grid.find('.flickity-slider').css({
                                        'transform': 'none',
                                        'display': 'grid',
                                        'grid-template-columns': isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                                        'gap': '1rem'
                                    });
                                }
                            } catch (error) {
                                console.log('Error in Flickity ready callback:', error);
                            }
                        }
                    }
                };
                
                // Initialize Flickity
                $grid.flickity(flickityOptions);
                
                // Add click handlers for custom buttons
                $prevButton.on('click', function() {
                    $grid.flickity('previous');
                });
                
                $nextButton.on('click', function() {
                    $grid.flickity('next');
                });
                
                // Ensure Flickity is properly initialized before setting up the resize timeout
                if ($grid.data('flickity')) {
                    setTimeout(function() {
                        try {
                            if ($grid.data('flickity')) {
                                $grid.flickity('resize');
                                
                                // Reapply grid styles if dragging is disabled
                                if (!shouldEnableDragging) {
                                    $grid.find('.flickity-slider').css({
                                        'transform': 'none',
                                        'display': 'grid',
                                        'grid-template-columns': isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                                        'gap': '1rem'
                                    });
                                }
                            }
                        } catch (error) {
                            console.log('Error in resize timeout:', error);
                        }
                    }, 100);
                }
            } catch (error) {
                console.log('Error initializing Flickity:', error);
            }
        });
    }
}

destroyFlickityFeaturedCollection = () => {
    $('.jsc-flickity-product-grid').each(function() {
        var $grid = $(this);
        try {
            if ($grid.data('flickity')) {
                console.log("destroyFlickityFeaturedCollection");
                $grid.find('.card-wrapper').css('height', 'auto');
                $grid.flickity('destroy');
            }
        } catch (error) {
            console.log('Error in destroyFlickityFeaturedCollection:', error);
        }
    });
}
checkCollectionTabsOverflow = () => {
    $('.jsc-collection-tabs').each(function() {
        var $tabs = $(this);
        var tabsWidth = 0;
        var containerWidth = $tabs.width();
        
        $tabs.find('.collection-tab').each(function() {
            tabsWidth += $(this).outerWidth(true);
        });
        
        // Add gap width (1rem = 16px)
        tabsWidth += ($tabs.find('.collection-tab').length - 1) * 16;
        
        if (tabsWidth > containerWidth) {
            $tabs.css('justify-content', 'flex-start');
        } else {
            $tabs.css('justify-content', 'center');
        }
    });

  //start: set a standard height for each tab content #14350
  var activePanelHeight = $('.tab-panel.active').outerHeight();
  //console.log("Active panel height:", activePanelHeight);
  var each_panel = $('.tab-panel');
  if (each_panel.length > 0) {
    each_panel.each(function() {
      //console.log($(this));
      $(this).css('height',activePanelHeight);
    });
  }
  //end: set a standard height for each tab content #14350
}
//End - Collection tabs & flickity featured collection
//Start - Product Tabs choose

clickswapproductabs = (evt,evnt) => {
    const $target = $(evnt.target);
    if ($target.closest('.product-slider-wrap-mobile').length > 0) {
        console.log("Clicked inside .product-slider-wrap-mobile");
        return;
    }
    // Check if the clicked tab is already active
    const wasAlreadyActive = $(evt).hasClass('active');
    
    if (wasAlreadyActive) {
        // If clicked tab is already active, deactivate it
        $(evt).removeClass('active').addClass('deactive');
        
        // Hide all product lists
        $('.product-list-wrap').hide();
        $('.product-list-wrap').removeClass('active');
        
        // Hide product slider or show a default state
        $('.product-slider-wrap').hide();
        
        // No need to run gridflickityproductTabsclick when deactivating
        return;
    }
    
    // First make all tabs inactive
    $(evt).parent().find('.multicolumn-list__item').removeClass('active').addClass('deactive');
    
    // Then make the clicked tab active
    $(evt).addClass('active').removeClass('deactive');
    
    // Get the data-tab attribute value
    var datatab = $(evt).attr('data-tab');
    
    // Hide all product lists
    $('.product-list-wrap').hide();
    $('.product-list-wrap').removeClass('active');
    
    // Show product slider
    $('.product-slider-wrap').show();
    
    // Show and activate the selected product list
    $('.product-list-' + datatab).addClass('active');
    
    // Always run gridflickityproductTabsclick when activating a new tab
    gridflickityproductTabsclick();
}
gridflickityproductTabs = () =>{
    $('.product-grid-flickity').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        imagesLoaded: true,
        prevNextButtons: false
    });
}
gridflickityproductTabsclick = () =>{
    $('.product-grid-flickity').flickity('destroy');
    $('.product-grid-flickity').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        imagesLoaded: true,
        prevNextButtons: false
    });
}
//End - Product Tabs choose

//Start - Trigger loyalty button
triggerLoyaltyButton = () => {
    var $iframe = $('#loyaltylion-beacon-frame');
    if ($iframe.length > 0 && $iframe[0].contentWindow) {
      var iframeDoc = $iframe[0].contentWindow.document;
      var $iframeBody = $(iframeDoc).find('body');
  
      var $matchingElement = $iframeBody.find('*').filter(function () {
        return $(this).text().trim() === "MZ Skin Rewards";
      });
  
      if ($matchingElement.length > 0) {
        $matchingElement[3].click();
      }
    }
}
//End - Trigger loyalty button
//Start - Custom quick view for flickity
chooseOptioncustom = (evt) => {
    var prodUrl = $(evt).attr('data-product-url');
    $(evt).parents('.slider-mobile-gutter').find('.gridquickClickOption quick-view-button[data-product-url="'+prodUrl+'"]').click();
    $(evt).parents('.slider-mobile-gutter').find('.gridquickClickOption').show();
}
closechooseOptioncustom = () => {
    $('.gridquickClickOption').hide();
}
openquickviewcustom = (evt) => {
    var prodUrl = $(evt).attr('data-product-url');
    $(evt).parents('.slider-mobile-gutter').find('.gridquickClickOption .quick-view__summary[data-product-url="'+prodUrl+'"]').click();
    $(evt).parents('.slider-mobile-gutter').find('.gridquickClickOption').show();
}
//End - Custom quick view for flickity

// start: Klaviyo BIS
showKlaviyoForm = (evt) => {
    var $productForm = $(evt).parents('.product-form');
    var $klaviyoForm = $productForm.find('.klaviyo-form-pdp');
    $klaviyoForm.attr('open', '');
}

toggleBISButton = (variant) => {
    var $notifyBtn = $('.product-form .klaviyo-bis-pdp');
    var $atcBtn = $('.product-form .product-form__submit.button');
    var $klaviyoForm = $('.product-form .klaviyo-form-pdp');
    var $variantInfo = $('.product-form .klaviyo-form-pdp .current-variant-info');
    var $stickyATC = $('.sticky-cart__form');

    if (variant.available) {
        $notifyBtn.addClass('d-none');
        $klaviyoForm.removeAttr('open');
        $atcBtn.removeClass('d-none');

        if ($stickyATC.length > 0) {
            var $stickyAtcBtn = $stickyATC.find('.product-form__submit.button');
            var $stickyNotifyBtn = $stickyATC.find('.klaviyo-bis-sticky');

            $stickyNotifyBtn.addClass('d-none');
            $stickyAtcBtn.removeClass('d-none');
        }
    }
    else {
        $notifyBtn.removeClass('d-none');
        $atcBtn.addClass('d-none');

        if ($stickyATC.length > 0) {
            var $stickyAtcBtn = $stickyATC.find('.product-form__submit.button');
            var $stickyNotifyBtn = $stickyATC.find('.klaviyo-bis-sticky');

            $stickyNotifyBtn.removeClass('d-none');
            $stickyAtcBtn.addClass('d-none');
        }
    }

    $variantInfo.attr('variant-id', variant.id);
}

subscribeBIS = (e) => {
    var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    var email = $(e).siblings('.klaviyo-form-email').val();
    var isEmailValid = false;
    
    var vid = parseInt($(e).parents('.klaviyo-form-pdp').find('.current-variant-info').attr('variant-id'));
    var $message = $(e).parents('.klaviyo-form-pdp').find('.klaviyo-form-message');
  
    if (emailRegex.test(email)) {
      isEmailValid = true;
      $message.addClass('d-none');
    }
    else {
      $message.html('Please input a valid email');
      $message.addClass('error');
      $message.removeClass('d-none');
    }
  
    if(isEmailValid == true) {
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": email
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::" + vid
              }
            }
          }
        }
      }
  
      var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
      };
  
      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=T7PNvg",requestOptions)
        .then(result => {
          console.log(result);
          $message.html("Please confirm your subscription to the waiting list, through the email that we have just sent you");
          $message.removeClass('error');
          $message.removeClass('d-none');
        })
        .catch(error => {
          console.log('error', error);
          $message.html("Error occurred! Please try again");
          $message.addClass('error');
          $message.removeClass('d-none');
        });
  
        const subscribePayload = {
          "data": {
            "type": "subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": email,
                    "properties": {
                      "newKey": "New Value"
                    }
                  },
                  "meta": {
                    "patch_properties": {
                      "append": {
                        "newKey": "New Value"
                      },
                      "unappend": {
                        "newKey": "New Value"
                      }
                    }
                  }
                }
              }
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": "VQvjtv"
                }
              }
            }
          }
        }
  
        var subscribeOption = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-07-15"
          },
          body: JSON.stringify(subscribePayload),
        };
  
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=T7PNvg",subscribeOption)
          .then(result => console.log(result))
          .catch(error => console.log('error', error));
        }
}

showBisForm = (e) => {
    var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
    var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');
    var $title = $modal.find('.jsc-bis-title');
    var $emailInput = $modal.find('.jsc-bis-email');
    var $message = $modal.find('.jsc-bis-message');
    var productTitle = $(e).attr('product-title');
    var variantID = $(e).attr('variant-id');
  
    $title.text(productTitle);
    $modal.find('.jsc-bis-variant').val(variantID);
    $emailInput.val('');
    $message.removeClass('show');
  
    $overlay.addClass('active');
    $modal.addClass('active');
}
  
hideBisForm = () => {
    var $overlay = $('.jsc-bis-form-wrapper .jsc-bis-overlay');
    var $modal = $('.jsc-bis-form-wrapper .jsc-bis-form-modal');
  
    $overlay.removeClass('active');
    $modal.removeClass('active');
}

popupSubscribeBIS = (e) => {
    var emailRegex = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    var email = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-email').val();
    var isEmailValid = false;
    var vid = parseInt($(e).parents('.jsc-bis-form-modal').find('.jsc-bis-variant').val());
    var $message = $(e).parents('.jsc-bis-form-modal').find('.jsc-bis-message');
  
    if (emailRegex.test(email)) {
      isEmailValid = true;
      $message.removeClass('show');
    }
    else {
      $message.html('Please input a valid email');
      $message.addClass('jsc-bis-error');
      $message.addClass('show');
    }
  
    if(isEmailValid == true) {
      const payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": email
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::" + vid
              }
            }
          }
        }
      }
  
      var requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2024-06-15"
        },
        body: JSON.stringify(payload),
      };
  
      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=T7PNvg",requestOptions)
        .then(result => {
          console.log(result);
          $message.html("Please confirm your subscription to the waiting list, through the email that we have just sent you");
          $message.removeClass('jsc-bis-error');
          $message.addClass('show');
        })
        .catch(error => {
          console.log('error', error);
          $message.html("Error occurred! Please try again");
          $message.addClass('jsc-bis-error');
          $message.addClass('show');
        });
  
        const subscribePayload = {
          "data": {
            "type": "subscription",
            "attributes": {
              "profile": {
                "data": {
                  "type": "profile",
                  "attributes": {
                    "email": email,
                    "properties": {
                      "newKey": "New Value"
                    }
                  },
                  "meta": {
                    "patch_properties": {
                      "append": {
                        "newKey": "New Value"
                      },
                      "unappend": {
                        "newKey": "New Value"
                      }
                    }
                  }
                }
              }
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": "VQvjtv"
                }
              }
            }
          }
        }
  
        var subscribeOption = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-07-15"
          },
          body: JSON.stringify(subscribePayload),
        };
  
        fetch("https://a.klaviyo.com/client/subscriptions/?company_id=T7PNvg",subscribeOption)
          .then(result => console.log(result))
          .catch(error => console.log('error', error));
      
    }
}
// end: Klaviyo BIS

//Start - Clickable Banner
initClickableBanner = () => {
  var $clickableBanner = $('.clickable-banner');
  if ($clickableBanner.length) {
    $clickableBanner.css('cursor', 'pointer');
    $clickableBanner.on('click', function() {
      var link = $(this).data('banner-link');
      if (link) {
        window.location.href = link;
      }
    });
  }
}
//End - Clickable Banner

upsellPDPSelectButton = () => {
  $('.jsc-upsell-checkbox').on('change', function () {
  var $wrapper = $(this).closest('.jsc-upsell-product-section');

  if ($(this).is(':checked')) {
    $wrapper.addClass('jsc-selected-upsell-product');
  } else {
    $wrapper.removeClass('jsc-selected-upsell-product');
  }
});

class UpsellProduct extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      souldout: 'price--sold-out',
      onsale: 'price--on-sale',
      nocompare: 'price--no-compare'
    };

    this.addToCart = this.querySelector('add-to-cart');
    this.price = this.querySelector('.price');
    this.variants = this.querySelector('select');
    if (this.variants) {
      this.variants.addEventListener('change', this.onSelectChange.bind(this));
    }
  }

  onSelectChange(event) {
    const variants = event.target;
    const variant = variants.options[variants.selectedIndex];
    const compare_at_price = parseInt(variant.dataset.compare_at_price || 0);
    const price = parseInt(variant.dataset.price || 0);
    const available = variant.dataset.available === 'true';
    const price_varies = variants.dataset.price_varies === 'true';
    const compare_at_price_varies = variants.dataset.compare_at_price_varies === 'true';

    // Remove classes
    this.price.classList.remove(this.classes.souldout);
    this.price.classList.remove(this.classes.onsale);
    this.price.classList.remove(this.classes.nocompare);

    // Add classes
    if (available === false) {
      this.price.classList.add(this.classes.souldout);
    }
    else if (compare_at_price > price && available) {
      this.price.classList.add(this.classes.onsale);
    }
    if (price_varies == false && compare_at_price_varies) {
      this.price.classList.add(this.classes.nocompare);
    }

    // Change price
    const price__regular = this.querySelector('.price__regular');
    price__regular.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;

    const price__sale = this.querySelector('.price__sale');
    price__sale.querySelector('.price-item--regular').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(compare_at_price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;
    price__sale.querySelector('.price-item--sale').innerHTML = `<price-money><bdi>${theme.Currency.formatMoney(price, theme.shopSettings.moneyFormat)}</bdi></price-money>`;

    var $productInfoElement = $(event.target).closest('.jsc-upsell-product-info');
    var $upsellCheckboxInput = $($productInfoElement).find('.jsc-upsell-checkbox');
    $upsellCheckboxInput.attr('data-atc-id', variant.value);
    console.log("Found:", $productInfoElement, $upsellCheckboxInput);
    console.log("Updated data-atc-id to:", variant.value);
  }
}
customElements.define('upsell-product', UpsellProduct);
}

setUpsellProductContainerMaxHeight = () => {
  var maxHeight = 0;
  $('.jsc-pdp-upsell .jsc-upsell-product-section').css('height', 'auto').each(function() {
    var h = $(this).outerHeight();
    if (h > maxHeight) maxHeight = h;
  });
  $('.jsc-pdp-upsell .jsc-upsell-product-section').css('height', maxHeight);
}
setUpsellProductMaxHeight = () => {
  var maxHeight = 0;
  // Find max height
  $('.jsc-pdp-upsell .jsc-upsell-product').css('height', 'auto').each(function() {
    var h = $(this).outerHeight();
    if (h > maxHeight) maxHeight = h;
  });
  $('.jsc-pdp-upsell .jsc-upsell-product').css('height', maxHeight);
  $('.jsc-pdp-upsell .jsc-upsell-product .jsc-upsell-product-info').css('height', maxHeight);
}

// Initialize Flickity for upsell carousel
initFlickityUpsellCarousel = () => {
  setUpsellProductContainerMaxHeight();
  setUpsellProductMaxHeight();
  var $carousels = $('.upsell-carousel');
  if ($carousels.length > 0) {
      $carousels.each(function() {
          var $carousel = $(this);
          var itemCount = $carousel.find('upsell-product').length;
          try {
            if ($carousel.data('flickity')) {
              $carousel.flickity('destroy');
            }
            $carousel.find('.flickity-button').remove();
            var shouldEnableDragging = itemCount > 1;

            var $prevButton = $('<button class="flickity-button flickity-button--previous" name="previous" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"/></svg></button>');
            var $nextButton = $('<button class="flickity-button flickity-button--next" name="next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"/></svg></button>');

            $carousel.append($prevButton, $nextButton);
            var flickityOptions = {
              cellAlign: 'left',
              contain: true,
              pageDots: false,
              prevNextButtons: false,
              groupCells: false,
              wrapAround: false,
              autoPlay: false,
              draggable: shouldEnableDragging,
              freeScroll: false,
              cellSelector: 'upsell-product',
              resize: true,
              imagesLoaded: true,
              adaptiveHeight: false
            };
            $carousel.flickity(flickityOptions);
            $prevButton.on('click', function() {
              $carousel.flickity('previous');
            });
            $nextButton.on('click', function() {
              $carousel.flickity('next');
            });

            $carousel.on('select.flickity', function(event, index) {
            var flkty = $carousel.data('flickity');
            var selectedIndex = flkty.selectedIndex;
            var lastIndex = flkty.slides.length - 1;

            if (selectedIndex === 0 && !flkty.options.wrapAround) {
              $prevButton.find('svg').css('opacity', '0.3');
            } else {
              $prevButton.find('svg').css('opacity', '1');
            }

            if (selectedIndex === lastIndex && !flkty.options.wrapAround) {
              $nextButton.find('svg').css('opacity', '0.3');
            } else {
              $nextButton.find('svg').css('opacity', '1');
            }
          });
          // Ensure Flickity is properly initialized before setting up the resize timeout
          if ($carousel.data('flickity')) {
              setTimeout(function() {
                  try {
                      if ($carousel.data('flickity')) {
                          $carousel.flickity('resize');
                      }
                  } catch (error) {
                      console.log('Error in resize timeout:', error);
                  }
              }, 100);
          }
          } catch (error) {
              console.log('Error initializing Flickity for upsell:', error);
          }
      });
  }
}

atcUpsell = (e) => {
  event.preventDefault();
  const _this = $(e);
  const _productForm = _this.closest('form[data-type="add-to-cart-form"]');
  const formData = _productForm.serializeArray();
  const formJson = {};
  const pdpUpsell = $('.jsc-pdp-upsell');
  var sealSubsType = '';
  formData.forEach(function(field) {
    var key = field.name;
    if (key.startsWith("subs_type")) {
        sealSubsType = key
    }
    formJson[key] = field.value;
  });
  console.log('formJson: ', formJson, formJson.quantity);

  var itemsArray = [];

  var item = {
    id: parseInt(formJson.id),
    quantity: parseInt(formJson.quantity)
  };

  if (formJson.selling_plan && formJson.selling_plan.trim() !== '') {
    item.selling_plan = formJson.selling_plan.trim();
  }

  itemsArray.push(item);

  pdpUpsell.find('.jsc-upsell-checkbox-wrap').each(function () {
    const $wrap = $(this);
    const $checkbox = $wrap.find('.jsc-upsell-checkbox');

    if ($checkbox.is(':checked')) {
      console.log('Checked upsell:', $checkbox);
      var checkBoxVarID =  $checkbox.attr('data-atc-id');
      var item = {
        id: parseInt(checkBoxVarID),
        quantity: 1
      };

      itemsArray.push(item);
    }
  });

  console.log("itemsArray", itemsArray);

  CartJS.addItems(itemsArray, {
    success: function(data) {
      console.log('Success:', data);
    },
    error: function(jqXHR, textStatus, errorThrown) {
      console.error('Error:', errorThrown, jqXHR);
    }
  });

}

//start: product media gallery
initFlickityMediaGallery = () => {

  var $media_gallery = $('.jsc-flickity-media-gallery');

  if ($media_gallery.length > 0) {

    

    $media_gallery.flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        imagesLoaded: true,
        prevNextButtons: true
    });

  }
  
}
//end: product media gallery

//start: image with text gallery section
function initTextImageFlickity() {
  var $galleries = $('.jsc-gallery-img-w-text-flickity');

  $galleries.each(function () {
    var $this = $(this);

    if (!$this.hasClass('flickity-enabled')) {
      $this.flickity({
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        draggable: true,
        imagesLoaded: true,
        prevNextButtons: false,
        pageDots: true
      });
    }
  });
}
//end: image with text gallery section

//start: pdp product description Read More
var jscReadMore_productDesc = () => {

  var prose = $(".product__description.rte");
    var fullText = prose.html(); // Store original content

    // Inject structure
    prose.html(`
        <div class="text-container">${fullText}</div>
        <button class="jsc-readMoreBtn">Read More</button>
    `);

    var textContainer = prose.find(".text-container");
    // var fadeOutEffect = prose.find(".fade-out");
    var readMoreBtn = prose.find(".jsc-readMoreBtn");

    // Function to check if content actually overflows and update button visibility
    const updateButtonVisibility = () => {
        // Ensure we're in the clamped state for accurate measurement
        const wasExpanded = textContainer.hasClass("expanded");
        textContainer.removeClass("expanded");
        
        // Force reflow to apply line-clamp
        textContainer[0].offsetHeight;
        
        // Get the full content height (scrollHeight) vs visible height (offsetHeight)
        const fullHeight = textContainer[0].scrollHeight;
        const visibleHeight = textContainer[0].offsetHeight;

        // Restore expanded state if it was expanded
        if (wasExpanded) {
            textContainer.addClass("expanded");
        }

        // Show or hide button based on overflow
        if (fullHeight > visibleHeight) {
            readMoreBtn.show();
        } else {
            readMoreBtn.hide();
        }
    };

    // Check overflow on page load
    updateButtonVisibility();

    // Check overflow on window resize
    $(window).on('resize', updateButtonVisibility);

    // Toggle read more / close
    readMoreBtn.click(function () {
        if (textContainer.hasClass("expanded")) {
            textContainer.removeClass("expanded");
            $(this).text("Read More");
        } else {
            textContainer.addClass("expanded");
            $(this).text("Read Less");
        }

        // Re-check overflow after state change to hide button if no content difference
        updateButtonVisibility();
    });
}
//end: pdp product description Read More



opencloseGWPbanner = (evt) => {
  $(evt).find('.cart-gwp-button-expand').toggleClass('active');
  $(evt).siblings('.cart-banner-gwp').toggle();
}

var multicolumnVideo = () => {
  const $videos = $('.jsc-multicolumn-video');

  // IntersectionObserver: play when visible, pause+mute when out of view
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      const video = entry.target;

      if (entry.isIntersecting) {
        // Play when visible
        video.play().catch(() => {});
      } else {
        // Pause and mute when out of view
        video.pause();
        video.muted = true;
      }
    });
  }, { threshold: 0.5 });

  $videos.each(function() {
    const video = this;

    // Default setup
    video.muted = true;
    video.loop = true;
    observer.observe(video);

    // If user unmutes one, mute all others
    $(video).on('volumechange', function() {
      if (!video.muted) {
        $videos.each(function() {
          if (this !== video) {
            this.muted = true;
          }
        });
      }
    });
  });
    
}

//start:: horizontal collection filter using metafield
onclickCollectionFilter = () => {
  if ($(window).width() <= 480) {

    $(document).on('click', '.disclosure-has-popup > summary', function (e) {
      const $details = $(this).closest('.disclosure-has-popup');
      const $dropdown = $details.find('.facets__display');

      setTimeout(() => {
        if ($details.attr('open')) {
          const rect = $details[0].getBoundingClientRect();
          const topPosition = rect.bottom + 30; // 30px below
          const leftPosition = 0;
  
          // Apply fixed styling to dropdown
          $dropdown.css({
            position: 'fixed',
            top: `${topPosition}px`,
            display: 'block',
            zIndex: 9999
          });
        } else {
          // Remove fixed styling when closed
          $dropdown.removeAttr('style');
        }
      }, 0);
    });

    
  }
}
//end:: horizontal collection filter using metafield